import type { ComparisonMode } from "../hooks/usePeriodAndComparison.js";

export interface ComparisonSelectorProps {
  vs: ComparisonMode;
  onChange: (vs: ComparisonMode) => void;
}

const OPTIONS: Array<{ value: ComparisonMode; label: string }> = [
  { value: "prev", label: "vs прошлый период" },
  { value: "week", label: "vs неделя назад" },
  { value: "month", label: "vs месяц назад" },
  { value: "year", label: "vs год назад" },
];

export function ComparisonSelector({ vs, onChange }: ComparisonSelectorProps) {
  return (
    <select
      value={vs}
      onChange={(e) => onChange(e.target.value as ComparisonMode)}
      style={{
        background: "var(--surface-card)",
        border: "1px solid var(--border-default)",
        color: "var(--text-primary)",
        borderRadius: "var(--radius-control)",
        padding: "0.45rem 0.7rem",
        fontSize: "0.85rem",
        cursor: "pointer",
        fontFamily: "inherit",
      }}
    >
      {OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}

export function comparisonLabel(vs: ComparisonMode): string {
  return OPTIONS.find((o) => o.value === vs)?.label ?? "vs прошлый период";
}
